/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 8-10-18.
 */
import {Text} from "../Text/TextQuestion";
import FileQuestion from "../../presentation/FileQuestion/FileQuestion";

export default Text(FileQuestion);
